import { apiService } from "./apiService";
import { IAlert } from "../types/alert";
import shortid from "shortid";
import _ from "lodash";
import { momentToMiliseconds, timestampToMoment } from "../utils/utils";

export interface IRequestAlerts {
  sort: Array<{ [key: string]: { order: "asc" | "desc" } }>;
  page: number;
  size: number;
  stop: boolean;
  caseId?: string;
  filterByAgency?: string;
}
export interface IResponseAlerts {
  total: number;
  results: IAlert[];
}

export const AlertsService = {
  save: (newAlert: any, caseId) => {
    const alertDB = AlertsService.formatAlertDB(newAlert);
    alertDB.alertId = shortid.generate();
    alertDB.caseId = caseId;
    return apiService.post("/api/alerts", {
      newAlert: { ...alertDB },
      refresh: true,
    });
  },
  update: (beforeCase: any, afterCase: any) => {
    const before = AlertsService.formatAlertDB(beforeCase);
    const after = AlertsService.formatAlertDB(afterCase);
    return apiService.put("/api/alerts", { updateAlert: { before, after } });
  },
  formatAlertDB: (newAlert: IAlert) => {
    const formatted = _.cloneDeep(newAlert);
    formatted.expirationDate = momentToMiliseconds(formatted.expirationDate);
    return formatted;
  },
  formatAlertFE: (newAlert: any): IAlert => {
    const formatted = _.cloneDeep(newAlert);
    formatted.expirationDate = timestampToMoment(formatted.expirationDate);
    return formatted;
  },
  get: (request: IRequestAlerts): Promise<IResponseAlerts> => {
    return apiService.post(`/api/alerts/all`, { request }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  status: (request): Promise<IResponseAlerts> => {
    return apiService.post(`/api/alerts/status`, { request }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  numbersByStatus: (): Promise<IResponseAlerts> => {
    return apiService.get("/api/alerts/numbersByStatus").then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  history: (alertId: string): Promise<any> => {
    return apiService.get(`/api/alerts/history/${alertId}`).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  getAlertByID: (alertId: string): Promise<IAlert | undefined> => {
    return apiService.get(`/api/alerts/${alertId}`).then((res) => {
      const { data } = res;
      return res.status === 200 && data.alert
        ? (AlertsService.formatAlertFE(data.alert) as IAlert)
        : undefined;
    });
  },
  handleBanAlertStatus: (alertId: string, banStatus: boolean) => {
    return apiService.put(`/api/alerts/banstatus`, {
      request: { alertId, banStatus },
    });
  },
};
